import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { SettingsProvider } from '@/providers/SettingsProvider';
import { useSessionStore } from '@/stores/session';

export function ProtectedRoute() {
  const { status } = useSessionStore();
  const location = useLocation();

  if (status === 'initializing') {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <SettingsProvider>
      <Outlet />
    </SettingsProvider>
  );
}
